import { Skeleton } from "@/app/components/shadcn/skeleton";

const ShippingTrackingResultSkeleton = () => (
  <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 lg:p-8 space-y-6">
    <div className="flex items-center justify-between">
      <div className="space-y-2">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-6 w-48" />
      </div>
      <Skeleton className="h-8 w-24 rounded-full" />
    </div>

    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="space-y-1.5">
          <Skeleton className="h-3.5 w-20" />
          <Skeleton className="h-5 w-32" />
        </div>
      ))}
    </div>

    <div className="space-y-3">
      <Skeleton className="h-4 w-24" />
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex gap-3 items-start">
          <Skeleton className="h-3 w-3 rounded-full mt-1 shrink-0" />
          <div className="space-y-1.5 flex-1">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-36" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ShippingTrackingResultSkeleton;
